import compose from 'recompose/compose';
import { withFormik } from 'formik';
import withState from 'recompose/withState';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import debounce from 'lodash/debounce';
import Inscription from './Inscription';
import withValidationData from '../../../hocs/withValidationData';
import { updateFieldValues, validateCreationForm, onFieldChange } from '../helpers';
import withMediaQueries from '../../../hocs/withMediaQueries';
import {
  trackDedicationDrawerOpenTab,
  trackDedicationDrawerCloseTab,
  trackDedicationDrawerChanged,
  trackDedicationDrawerDeleteAll,
  trackDedicationDrawerSaveTab,
} from 'src/client/js/analytics/category/product';
import formatInscription from 'src/common/utils/format-inscription';


const debouncedValidation = debounce(
  (values, props, config) => validateCreationForm(values, props, config),
  500
);

const enhance = compose(
  withMediaQueries,
  withValidationData,
  withFormik({
    mapPropsToValues: props => ({
      base: '',
      inscription: props.productCustomisation.inscription,
    }),
    handleSubmit: (fields, { props }) => {
      trackDedicationDrawerSaveTab();
      const values = updateFieldValues(fields);
      props.onFormikSubmit(values);
    },
  }),
  withState(
    'currentCount',
    'setCurrentCount',
    props => props.drawer.maxCharacters - props.values.inscription.length,
  ),
  withHandlers({
    onChange: props => {
      const handleChange = onFieldChange(props);
      return event => {
        const value = formatInscription(event.target.value);

        if (!value) {
          trackDedicationDrawerDeleteAll();
        } else {
          trackDedicationDrawerChanged();
        }

        event.target.value = value;

        handleChange(event);
        debouncedValidation({ inscription: value }, props, { enableSetErrors: true });
        props.setCurrentCount(props.drawer.maxCharacters - value.length);
      };
    },
  }),
  lifecycle({
    componentDidMount() {
      trackDedicationDrawerOpenTab();
    },
    componentWillUnmount() {
      trackDedicationDrawerCloseTab();
    }
  })
);

export default enhance(Inscription);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/Inscription/index.js